import { render, staticRenderFns } from "./asLoginForm.vue?vue&type=template&id=b562a9b0&"
import script from "./asLoginForm.vue?vue&type=script&lang=ts&"
export * from "./asLoginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports